import { EntraIdGroupsEffects } from "./entra-id-groups.effects";

export const effects: any[] = [EntraIdGroupsEffects];

export * from "./entra-id-groups.effects";
